import { nodeConstants } from '../_constants'

export function nodesHasErrored(state = false, action) {
  switch (action.type) {
    case nodeConstants.NODE_HAS_ERRORED:
      return action.hasErrored;
    default:
      return state;
  }
}

export function nodesIsLoading(state = false, action) {
  switch (action.type) {
    case nodeConstants.NODE_IS_LOADING:
      return action.isLoading;
    default:
      return state;
  }
}

export function nodes(state = [], action) {
  switch (action.type) {
    case nodeConstants.NODE_FETCH_DATA_SUCCESS:
      let nodes = [];
      // Handle different response formats:
      // 1. Pagination format with entities array (for root nodes)
      // 2. Single node with children array (for node details)
      // 3. Direct array (fallback)
      let nodeData;
      if (action.nodes.entities) {
        // Pagination response (root nodes)
        nodeData = action.nodes.entities;
      } else if (action.nodes.children) {
        // Single node response with the currently loaded branch
        nodeData = [action.nodes].concat(action.nodes.children || []);
      } else if (Array.isArray(action.nodes)) {
        // Already an array
        nodeData = action.nodes;
      } else {
        // Single node or unknown format
        nodeData = [action.nodes];
      }
      nodes[action.id] = nodeData;
      return Object.assign({}, state, nodes);
    case nodeConstants.NODE_CLEAR_BRANCHES:
      return {};
    default:
      return state;
  }
}

export function rootId(state = 'all', action) {
  switch (action.type) {
    case nodeConstants.NODE_SET_ROOT:
      return action.rootId;
    default:
      return state;
  }
}
